<template>
    <div>
        <b-tabs v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6>Carga Documentos</h6>
                </template>
                <template v-if="tabIndex == 0">
                    <subir-documentos @tabIndex="changeTab"></subir-documentos>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import SubirDocumentos from '@/components/cargamasiva/SubirDocumentos'

export default {
    name:'cargarDocumentos',
    components:{
        SubirDocumentos,
    },
    data:()=> {
        return {
            tabIndex : 0
        }
    },
    methods: {
        changeTab(value) {
            this.tabIndex = value;
        },
    },
}
</script>